import type { Allocation, AllocationChange, DailyLoad } from '../../DTOS/ResourcePlanning';

export const loadKey = (load: Pick<DailyLoad, 'userId' | 'date'>) => `${load.userId}:${load.date}`;

/** Reduce each selected person's daily total proportionally across all their projects, to the minute. */
export const fitToCapacity = (allocations: Allocation[], loads: DailyLoad[]): AllocationChange[] => {
  const byDay = new Map<string, Allocation[]>();
  for (const allocation of allocations) {
    const key = loadKey(allocation);
    const rows = byDay.get(key) || [];
    rows.push(allocation);
    byDay.set(key, rows);
  }
  const changes: AllocationChange[] = [];
  for (const load of loads) {
    const rows = byDay.get(loadKey(load)) || [];
    const total = rows.reduce((sum, row) => sum + row.minutes, 0);
    // Never fit an incomplete day: filtered/partial data could leave other projects overloaded.
    if (total !== load.minutes) throw new Error('Reincarcati planificarea: lipsesc alocari din ziua selectata.');
    if (total <= load.capacity) continue;
    const targets = rows.map(row => ({ row, minutes: Math.floor(row.minutes * load.capacity / total), remainder: row.minutes * load.capacity % total }))
      .sort((a, b) => b.remainder - a.remainder || a.row.id.localeCompare(b.row.id));
    let remaining = load.capacity - targets.reduce((sum, target) => sum + target.minutes, 0);
    for (const target of targets) {
      if (remaining > 0) { target.minutes++; remaining--; }
      if (target.minutes === target.row.minutes) continue;
      changes.push({ id: target.row.id, expectedVersion: target.row.rowVersion,
        ...(target.minutes > 0 ? { minutes: target.minutes } : { delete: true }) });
    }
  }
  return changes;
};
